'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { useCategoryFilters } from '@/app/_lib/hooks';
import SortSelect from './SortSelect';
const CategoryFilters = dynamic(() => import('./CategoryFilters'), {
  ssr: false
});
import CategoryWidgetNav from './CategoryWidgetNav';
import SelectedFilters from './SelectedFilters';
import ProductGrid from './ProductGrid';
import MobileFiltersPanel from './MobileFiltersPanel';

// Sort options for the order by dropdown
const SORT_OPTIONS = [{
  key: '',
  label: 'View All'
}, {
  key: 'best_seller',
  label: 'Best Seller'
}, {
  key: 'price_low_to_high',
  label: 'Price | Low To High'
}, {
  key: 'price_high_to_low',
  label: 'Price | High To Low'
}, {
  key: 'recently_added',
  label: 'Recently Added'
}, {
  key: 'designer',
  label: 'Designer'
}, {
  key: 'supplier',
  label: 'Brand'
}];

/**
 * CategoryProducts - Product grid with filters
 *
 * Uses useCategoryFilters hook for all filter state management.
 * This component handles only UI rendering and mobile panel state.
 */
export default function CategoryProducts(t0) {
  const $ = _c(60);
  const {
    category,
    initialProducts,
    categoryId
  } = t0;
  let t1;
  if ($[0] !== category || $[1] !== categoryId || $[2] !== initialProducts) {
    t1 = {
      categoryId,
      category,
      initialProducts
    };
    $[0] = category;
    $[1] = categoryId;
    $[2] = initialProducts;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    products,
    isLoading,
    totalProductCount,
    filters,
    filtersActive,
    resolvedFilters,
    updateFilters,
    removeFilter,
    clearAll,
    setSort
  } = useCategoryFilters(t1);
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  let t2;
  if ($[4] !== setSort) {
    t2 = sortOption => {
      setSort(sortOption.key || null);
    };
    $[4] = setSort;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleSortChange = t2;
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex items-center border-b-1 border-gray-8 pb-3"><FontAwesomeIcon icon={faSliders} className="text-primary text-xl mr-3" width="16" /><span className="text-md text-primary">Filter</span></div>;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== category || $[8] !== filters || $[9] !== updateFilters) {
    t4 = <aside className="relative flex flex-col items-start h-full hidden lg:block w-[225px] min-w-[225px] mr-12 pt-4">{t3}<CategoryFilters category={category} suppliers={category.suppliers} designers={category.designers} tagGroups={category.tagGroups} priceStructure={category.priceStructure} currentFilters={filters} updateHash={updateFilters} designersDirectory={category.designersDirectory} variant="desktop" /></aside>;
    $[7] = category;
    $[8] = filters;
    $[9] = updateFilters;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== category) {
    t5 = <CategoryWidgetNav category={category} parentClasses="grid mb-6 lg:mb-8" />;
    $[11] = category;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = category.display_name || category.category_name;
  let t7;
  if ($[13] !== t6) {
    t7 = <div className="flex items-center justify-between mb-4 pb-3 border-b-1 border-gray-8"><h1 className="text-2xl font-extralight capitalize">{t6}</h1></div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = `shrink-0 text-sm text-light lg:text-xs lg:text-light whitespace-nowrap order-1 ${isLoading ? "opacity-50" : ""}`;
  let t9;
  if ($[15] !== filtersActive || $[16] !== products.length || $[17] !== totalProductCount) {
    t9 = filtersActive && products.length < totalProductCount && <span className="text-light lg:text-extra-light"> ({totalProductCount} total)</span>;
    $[15] = filtersActive;
    $[16] = products.length;
    $[17] = totalProductCount;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== products.length || $[20] !== t8 || $[21] !== t9) {
    t10 = <div className={t8}>{products.length} Products{t9}</div>;
    $[19] = products.length;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setMobileFiltersOpen(true);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <button type="button" onClick={t11} className="flex items-center lg:hidden py-2 px-3 -mr-3 order-2"><FontAwesomeIcon icon={faSliders} className="text-xl mr-2" width="16" /><span className="text-md">Filter</span></button>;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = filters.sort_by || "";
  let t14;
  if ($[25] !== handleSortChange || $[26] !== t13) {
    t14 = <div className="shrink-0 whitespace-nowrap order-3 lg:order-4 lg:ml-auto"><SortSelect options={SORT_OPTIONS} selectedKey={t13} onSelect={handleSortChange} /></div>;
    $[25] = handleSortChange;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== clearAll || $[29] !== removeFilter || $[30] !== resolvedFilters) {
    t15 = <div className="basis-full mt-3 lg:basis-auto lg:mt-0 lg:ml-5 order-4 lg:order-3"><SelectedFilters resolvedFilters={resolvedFilters} onRemoveFilter={removeFilter} onClearAll={clearAll} /></div>;
    $[28] = clearAll;
    $[29] = removeFilter;
    $[30] = resolvedFilters;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t14 || $[34] !== t15) {
    t16 = <div className="flex flex-wrap items-center justify-between lg:justify-start mb-2 lg:mb-10">{t10}{t12}{t14}{t15}</div>;
    $[32] = t10;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== clearAll || $[37] !== filtersActive || $[38] !== isLoading || $[39] !== products) {
    t17 = <ProductGrid products={products} isLoading={isLoading} hasFilters={filtersActive} onClearFilters={clearAll} />;
    $[36] = clearAll;
    $[37] = filtersActive;
    $[38] = isLoading;
    $[39] = products;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t16 || $[42] !== t17 || $[43] !== t5 || $[44] !== t7) {
    t18 = <div className="mt-0 lg:mt-4 w-full pb-[150px]">{t5}{t7}{t16}{t17}</div>;
    $[41] = t16;
    $[42] = t17;
    $[43] = t5;
    $[44] = t7;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setMobileFiltersOpen(false);
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== category || $[48] !== filters || $[49] !== updateFilters) {
    t20 = <CategoryFilters category={category} suppliers={category.suppliers} designers={category.designers} tagGroups={category.tagGroups} priceStructure={category.priceStructure} currentFilters={filters} updateHash={updateFilters} designersDirectory={category.designersDirectory} variant="mobile" />;
    $[47] = category;
    $[48] = filters;
    $[49] = updateFilters;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  let t21;
  if ($[51] !== isLoading || $[52] !== mobileFiltersOpen || $[53] !== products.length || $[54] !== t20) {
    t21 = <MobileFiltersPanel open={mobileFiltersOpen} onClose={t19} productCount={products.length} isLoading={isLoading}>{t20}</MobileFiltersPanel>;
    $[51] = isLoading;
    $[52] = mobileFiltersOpen;
    $[53] = products.length;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  let t22;
  if ($[56] !== t18 || $[57] !== t21 || $[58] !== t4) {
    t22 = <div className="flex flex-col lg:flex-row align-start items-stretch">{t4}{t18}{t21}</div>;
    $[56] = t18;
    $[57] = t21;
    $[58] = t4;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  return t22;
}